export function usePostMessage() {
  interface PostMessageData {
    type?: string
    [key: string]: unknown
  }

  const postMessageToParent = (message: PostMessageData | string, targetOrigin = "*") => {
    try {
      const messageData = typeof message === "string" ? message : JSON.stringify(message)
      // 如果在 iframe 中，發送給 parent window
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(messageData, targetOrigin)
      } 
    } catch (error) {
      console.error("Failed to send message to parent:", error)
    }
  }

  /**
   * 檢查 URL queryString 是否包含 iframeClose=true，如果是則發送關閉訊息
   */
  const handleIframeCloseQuery = async () => {
    const route = useRoute()

    // 嘗試從多個來源獲取 query 參數
    let shouldClose = false

    // 1. 從 Vue Router 獲取
    if (route.query.iframeClose === "true") {
      shouldClose = true
    }

    // 2. 從 window.location.search 獲取
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get("iframeClose") === "true") {
      shouldClose = true
    }

    // 3. 從 window.location.hash 中的 query 獲取 (處理 hash 模式)
    const { hash } = window.location
    if (hash.includes("?")) {
      const hashQuery = hash.split("?")[1]
      const hashParams = new URLSearchParams(hashQuery)
      if (hashParams.get("iframeClose") === "true") {
        shouldClose = true
      }
    }

    if (shouldClose) {
      // 發送關閉訊息給 parent window (自己)
      postMessageToParent({ method: "iframeClose" }, window.location.origin)

      return true
    }

    return false
  }

  return {
    postMessageToParent,
    handleIframeCloseQuery
  }
}

export default usePostMessage
